import type { PermissionSelector } from "@/hooks/usePermission";

export const canManageAddresses: PermissionSelector = (x) => x.addressManagement.canManageAddresses;

export const canEditAddresses: PermissionSelector = (x) => x.addressManagement.canEditAddress;
